<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <AdminKycBack
      title="Основная информация об организации"
      @back="handleBack"
    />

    <div :class="b('fields')">
      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Страна регистрации организации") }}
        </h4>

        <UIInput
          view="light"
          :is-readonly="true"
          v-model="kybBasicInfo.country"
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Название организации") }}
        </h4>

        <UIInput
          view="light"
          :is-readonly="true"
          v-model="kybBasicInfo.organisation"
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Регистрационный номер") }}
        </h4>

        <UIInput
          view="light"
          :is-readonly="true"
          v-model="kybBasicInfo.regional_number"
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Дата регистрации") }}
        </h4>

        <SharedDate
          format="dd-MM-yyyy"
          :is-readonly="true"
          v-model:date="kybBasicInfo.registration_date"
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Номер Налогоплательщика") }}
        </h4>

        <UIInput view="light" :is-readonly="true" v-model="kybBasicInfo.inn" />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Уставный капитал") }}
        </h4>

        <UIInput
          view="light"
          :is-readonly="true"
          v-model="kybBasicInfo.capital"
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Валюта уставного капитала") }}
        </h4>

        <UIInput
          view="light"
          :is-readonly="true"
          v-model="kybBasicInfo.capital_currency"
        />
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Деятельность лицензируется?") }}
        </h4>

        <div :class="b('field-radios')">
          <div :class="b('field-radio')">
            <SharedRadio
              view="light"
              :checked-value="true"
              :is-readonly="true"
              v-model:value="kybBasicInfo.licensed"
            />

            <p :class="b('field-radio-label')">
              {{ $t("Да") }}
            </p>
          </div>

          <div :class="b('field-radio')">
            <SharedRadio
              view="light"
              :checked-value="false"
              :is-readonly="true"
              v-model:value="kybBasicInfo.licensed"
            />

            <p :class="b('field-radio-label')">
              {{ $t("Нет") }}
            </p>
          </div>
        </div>
      </div>

      <div :class="b('field')">
        <h4 :class="b('field-label')">
          {{ $t("Телеграм для связи") }}
        </h4>

        <UIInput
          view="light"
          :is-telegram="true"
          :is-readonly="true"
          v-model="kybBasicInfo.telegram"
        />
      </div>
    </div>
  </div>
</template>
